/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Trigger_Lesson_TimeInputs */

const en_templates_trigger_lesson_time = /** @type {(inputs: Templates_Trigger_Lesson_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At lesson time`)
};

const he_templates_trigger_lesson_time = /** @type {(inputs: Templates_Trigger_Lesson_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בזמן השיעור`)
};

/**
* | output |
* | --- |
* | "At lesson time" |
*
* @param {Templates_Trigger_Lesson_TimeInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_trigger_lesson_time = /** @type {((inputs?: Templates_Trigger_Lesson_TimeInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Trigger_Lesson_TimeInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_trigger_lesson_time(inputs)
	return he_templates_trigger_lesson_time(inputs)
});